import Component from '../abstracts/Component';

export default class QuadImageComponent extends Component {
  constructor(compEl) {
    super(compEl);
    this.cardsBlock = this.$component.querySelector('[data-cards]');
    this.mainBlock = this.$component.querySelector('[data-main]');
    this.heightDiff = this.cardsBlock.offsetHeight - this.mainBlock.offsetHeight;
    this.prevScroll = 0;
    this.currentScroll = 0;
  }

  initObserver() {
    let options = {
      rootMargin: '0px',
      threshold: [0],
    };
    let callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', () => {
            this.prevScroll = document.querySelector('header').offsetHeight;
            let rect = this.cardsBlock.getBoundingClientRect();
            if (rect.top < document.querySelector('header').offsetHeight) {
              this.currentScroll = parseInt(rect.top);
              let diff = (this.prevScroll - this.currentScroll) * 0.6;
              this.mainBlock.style.transform =
                diff < this.heightDiff
                  ? `translateY(${diff}px)`
                  : `translateY(${this.heightDiff}px)`;
            } else {
              this.mainBlock.style.transform = 'translateY(0)';
            }
          });
        }
      });
    };
    let observer = new IntersectionObserver(callback, options);
    observer.observe(this.cardsBlock);
  }

  render() {
    this.log('Rendering...');
    if (this.cardsBlock) {
      this.initObserver();
    }
  }
}
